import { Leaf } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200 py-8">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center space-x-3 mb-4 md:mb-0">
            <div className="p-2 rounded-xl"> 
            <img
                      src='/logo-1.svg'
                      alt='logo'
                      className="w-full h-7 object-cover group-hover:scale-120 transition-transform duration-700"
                    />
            </div>
            <h3 className="text-xl font-bold bg-gradient-to-r from-red-600 via-green-600 to-purple-600 bg-clip-text text-transparent">Nature's Bite</h3>
          </div>

          <div className="flex items-center space-x-8 text-sm text-gray-600">
            <a href="#home" className="hover:text-blue-600 transition-colors">Home</a>
            <a href="#menu" className="hover:text-blue-600 transition-colors">Menu</a>
            <a href="#about" className="hover:text-blue-600 transition-colors">About</a>
            <span>&copy; 2025 Nature's Bite. Contact us: bite.natures@gmail.com.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
